import React from 'react';

import PopulationSelect from 'client/common/components/audience-settings/population-select';
import {SelectWithBodyPopup} from 'client/common/components/lego';
import {convertToLegoOptions} from 'client/common/components/audience-settings/helpers';
import {
    AudienceCategoryInfo,
    AudienceCategoryPossibleValues,
    AudienceCategoryValue
} from 'client/common/types';

interface TargetingGeoProps {
    canUsePopulationSelect?: boolean;
    categories: AudienceCategoryInfo[];
    disabled: boolean;
    handleGeoChange: (value: AudienceCategoryValue[]) => void;
    selectedGeo: string[];
    selectedGeoValue: string[];
    targetingGeoLabels: string;
    targetingGeoOptions: AudienceCategoryPossibleValues;
}

export default function TargetingGeo(props: TargetingGeoProps) {
    const {
        canUsePopulationSelect,
        categories,
        disabled,
        handleGeoChange,
        selectedGeo,
        selectedGeoValue,
        targetingGeoLabels,
        targetingGeoOptions
    } = props;

    return canUsePopulationSelect ? (
        <PopulationSelect
            categories={categories}
            geoValue={selectedGeo}
            onChange={handleGeoChange}
            disabled={disabled}
        />
    ) : (
        <SelectWithBodyPopup
            disabled={disabled}
            placeholder={targetingGeoLabels}
            showAlwaysPlaceholder
            onChange={e => {
                void handleGeoChange(e.target.value);
            }}
            options={convertToLegoOptions(targetingGeoOptions)}
            value={selectedGeoValue}
            view='dl-clear'
            size='m'
            width='max'
        />
    );
}
